import { TeddyBearIcon } from './TeddyBearIcon';

/**
 * author: Andy Allsopp
 * id A9D12403-70AF-4022-9AB1-B9CE5EF1F9E9
 * name teddy-bear
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/teddy-bear.svg
 * tags
 * - Holiday 
 * - Home Automation 
 */
export const PlayRoomIcon = TeddyBearIcon;
export default PlayRoomIcon